module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "list-group"
  }, [_vm._l((_vm.items), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "list-group-item"
    }, [_c('div', {
      staticClass: "btn-group",
      staticStyle: {
        "margin-right": "1rem"
      }
    }, [_c('button', {
      staticClass: "btn btn-sm btn-info",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.moveUp(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-up"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-info",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.moveDown(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-down"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeItem(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "hidden",
        "name": _vm.name
      },
      domProps: {
        "value": item
      }
    }), _vm._v(" "), _c('span', [_vm._v("— " + _vm._s(item))])])
  }), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "form-row align-items-center",
    staticStyle: {
      "margin-left": "0",
      "margin-right": "0"
    }
  }, [_c('div', {
    staticClass: "col-auto"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success",
    staticStyle: {
      "margin-right": "1rem"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addItem()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newText),
      expression: "newText"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Neuen Inhalt eingeben"
    },
    domProps: {
      "value": (_vm.newText)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addItem()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newText = $event.target.value
      }
    }
  })])])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3564c7c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/ItemList.vue
// module id = 104
// module chunks = 0